import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '@routes/booking.js'
import BookingApp from '@views/Booking.vue'

// Style
import './components/modal'

const prebook_init = () => {
    window.Log = () => {
        // if (!prebook_frontend.debug) return
        const args = Array.prototype.slice.call(arguments)
        console.log('%c[Prebook]', 'background: purple; color: #fff; font-size: 10px; padding: 1px 2px; border-radius: 3px', ...args)
    }

    // Mount
    const mountables = document.querySelectorAll('[data-prebook]')
    
    if (!mountables || !mountables.length) return;

    mountables.forEach(mountable => {
        
        // Widget Mode.
        const app = createApp(BookingApp)
        app.use(createPinia())
        app.use(router())
        app.mount(mountable)
        
        var config = {}
        // Instance Configurations
        if (mountable.hasAttribute('data-prebook')) {
            const str = mountable.getAttribute('data-prebook')
           if ( str !== 'undefined' ) {
                try {
                    config = JSON.parse(str) 
                } catch (e) {
                    console.error('Invalid Config', e)
                }
            }
        }
    
        app.config.globalProperties.config = config || {}
        app.config.globalProperties.isWidget = config.isWidget || false
        app.config.globalProperties.Log = window.Log
        app.config.globalProperties.Image = (path) => {
            return prebook.url.assets + 'images/' + path
        }
    })

    // Prebook Open
    window.addEventListener('DOMContentLoaded', () => {
        let config = localStorage.getItem('prebook_open')
        if ( !config ) return;

        let modals = document.querySelectorAll('[data-prebook]')
        if ( !modals ) return;

        
        modals.forEach(modal => {
            let modalConfig = modal.getAttribute('data-prebook') || '{}'

            if ( modalConfig == config ) {
                
                let parentModal = modal.closest('.prebook-modal')
                if ( parentModal ) {
                    parentModal.classList.remove('hidden')
                }
                
                modal.parentElement.classList.remove('hidden')

                // Remove from local storage
                localStorage.removeItem('prebook_open')
            }
        })
    })
}

prebook_init()

